import { IChangePasswordData } from '../pages/changePasswordPage/changePasswordInterface';
import { post } from './apiService';

export const setChangePassword = async (data: IChangePasswordData) => {
  return await post('/user/me/change-password', data);
};
